import * as z from "zod";

export const createTiktokAdsAudience = {
  name: "createTiktokAdsAudience" as const,
  input: z.object({ advertiserId: z.string(), name: z.string() }),
  output: z.object({
    audience: z.object({ id: z.string(), name: z.string() }).nullable(),
    error: z.string().optional(),
  }),
};
